import React from 'react';

function WhatIOfferComponent() {
  return (
    <section id='fetish-list' className='container mx-auto px-6'>
      <h5 className='text-xl font-bold text-center mb-2'>What I Offer</h5>

      <h3 className='text-4xl mt-2 text-center font-titleFont'>Kinks and Fetishes</h3>
      <ul className={`grid gap-1 text-sm py-6 lg:justify-center text-center`}>
        <li>✅ Anal / Fisting</li>
        <li>✅ Armpit Worship</li>
        <li>✅ Ballbusting</li>
        <li>✅ Bastinado</li>
        <li>
          ✅ Bondage: steel, chains, leather, shrink wrap, straightjacket,
          predicament, posture punishment.
        </li>
        <li>✅ Boot Worship/Domination</li>
        <li>✅ Breath Play</li>
        <li>✅ Cashpoint & ATM Sessions</li>
        <li>✅ Caning</li>
        <li>✅ CBT</li>
        <li>
          ✅ CEI (NO INTIMATE TOUCHING. CONDOM OF CUM CAN BE PROVIDED UPON
          REQUEST, MUST GIVE NOTICE)
        </li>
        <li>✅ Chastity (TRAINING AND KEYHOLDING)</li>
        <li>✅ Consensual Coercion: blackmail fantasy, debt contracts</li>
        <li>✅ Corporal Punishment</li>
        <li>✅ Degradation</li>
        <li>✅ Double Domination (2-3 WEEKS NOTICE TO ARRANGE)</li>
        <li>✅ Domestic tasks (MAID DUTIES/HUMAN FURNITURE)</li>
        <li>✅ Encouraged Bi Play (2-3 WEEKS NOTICE TO ARRANGE)</li>
        <li>✅ Face Sitting (FULLY CLOTHED ONLY)</li>
        <li>✅ Face Slapping</li>
        <li>✅ Fetish Clothing Worship: Latex, Leather, PVC Worship</li>
        <li>✅ Financial Domination</li>
        <li>✅ Flogging</li>
        <li>✅ Food & Object Crushing: Foot/High Heel Feeding</li>
        <li>✅ Foot Worship</li>
        <li>✅ Gags</li>
        <li>✅ Glove Fetish</li>
        <li>✅ Headscissors/Muscle Domination</li>
        <li>✅ Human Ashtray</li>
        <li>✅ Humiliation</li>
        <li>✅ High Heel Worship</li>
        <li>✅ Impact Play</li>
        <li>✅ Medical Play</li>
        <li>✅ Needle Play</li>
        <li>✅ Nipple teasing/torment</li>
        <li>✅ Nylon Fetish & Worship</li>
        <li>✅ Objectification</li>
        <li>✅ Orgasm Control: edging, denial, fleshlight edging.</li>
        <li>✅ OTK Spanking</li>
        <li>✅ Pegging: beginner - experienced.</li>
        <li>✅ Pet Play</li>
        <li>✅ Public Humiliation</li>
        <li>✅ Punishment Training</li>
        <li>✅ Scent Play: Sweaty/Smelly Worship</li>
        <li>✅ Sensation Play</li>
        <li>✅ Shopping Trips</li>
        <li>✅ Silent & Ignore</li>
        <li>
          ✅ Sissification / Cross Dressing: Dress up, Make up Sessions,
          Tutorials. Encouragement/Humiliation.
        </li>
        <li>✅ Slave Training</li>
        <li>✅ Smoking</li>
        <li>✅ Sneaker/Trainer/Shoe Worship</li>
        <li>✅ Socks</li>
        <li>✅ Spanking</li>
        <li>✅ SPH Small Penis Humiliation</li>
        <li>✅ Submission Holds</li>
        <li>✅ Tie & Tease</li>
        <li>✅ Tickle Torment</li>
        <li>✅ Trampling</li>
        <li>✅ Temperature Play: Ice, Wax, Heat Spray.</li>
        <li>✅ Vaping</li>
        <li>✅ Watersports</li>
        <li>
          ✅ Workout Clothes Worship: yoga pants, gym leggings, spandex, gymwear
        </li>
        <li>✅ Whipping</li>
        <li>
          ✅ Wrestling: No fighting back, just let Me beat you. Boxing,
          Scissorholding, RNC, TapOuts, Throat Crushing.
        </li>
      </ul>

      <div>
        <p className='text-center py-4'>
          Additional requests can be added to your session, for example: Foot
          dust, nail clippings, sweaty socks, smelly trainers, sweaty armpits,
          dirty underwear, etc. Make a note in your email of your additional
          requests.
        </p>
      </div>

      <h6 className='text-lg font-bold mt-6 text-center'>I DO NOT OFFER:</h6>
      <ul className={`grid gap-1 text-sm py-6 lg:justify-center text-center`}>
        <li>
          <span className='text-black'>✖</span> Sessions to subs with no limits.
        </li>
        <li>
          <span className='text-black'>✖</span> No kissing.
        </li>
        <li>
          <span className='text-black'>✖</span> No nudity.
        </li>
        <li>
          <span className='text-black'>✖</span> No handjobs.
        </li>
        <li>
          <span className='text-black'>✖</span> No blowjobs.
        </li>
        <li>
          <span className='text-black'>✖</span> No footjobs.
        </li>
        <li>
          <span className='text-black'>✖</span> No cunnilingus.
        </li>
        <li>
          <span className='text-black'>✖</span> No sex.
        </li>
        <li>
          <span className='text-black'>✖</span> No naked body worship.
        </li>
        <li>
          <span className='text-black'>✖</span> No hardsports.
        </li>
        <li>
          <span className='text-black'>✖</span> No vomit.
        </li>
        <li>
          <span className='text-black'>✖</span> No race play.
        </li>
        <li>
          <span className='text-black'>✖</span> No age play.
        </li>
        <li>
          <span className='text-black'>✖</span> No public humiliation involving
          unconsenting general public.
        </li>
      </ul>

      <p className='mt-4 lg:mt-8 text-sm text-center'>
        If there are any kinks/fetishes not on My lists that you wish to inquire
        about, you may do so respectfully.
      </p>
    </section>
  );
}

export default WhatIOfferComponent;
